// extracted by mini-css-extract-plugin
export default {"InputGroup":"InputGroup_InputGroup__JZgz4"};